define('OutSystems/ClientRuntime/Request',["require", "exports", "tslib", "./modules/Common/RequestUtils", "./NativeHttp"], function (require, exports, tslib_1, RequestUtils, NativeHttp) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.createHttpRequest = void 0;
    var RequestReadyStates = {
        Unsent: 0,
        Opened: 1,
        HeadersReceived: 2,
        Loading: 3,
        Done: 4,
    };
    var MULTIPLE_NEWLINE_RX = /[\r\n]+/;
    var DEFAULT_BASE_PATH = "/";
    var XmlHttpResponse = (function () {
        function XmlHttpResponse(request, xhr) {
            this.request = request;
            this.xhr = xhr;
        }
        Object.defineProperty(XmlHttpResponse.prototype, "complete", {
            get: function () {
                return this.request.isDone();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(XmlHttpResponse.prototype, "responseUrl", {
            get: function () {
                return this.xhr.responseURL;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(XmlHttpResponse.prototype, "statusCode", {
            get: function () {
                return this.xhr.status;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(XmlHttpResponse.prototype, "statusText", {
            get: function () {
                return this.xhr.statusText;
            },
            enumerable: false,
            configurable: true
        });
        XmlHttpResponse.prototype.getHeader = function (name) {
            return this.xhr.getResponseHeader(name);
        };
        Object.defineProperty(XmlHttpResponse.prototype, "headers", {
            get: function () {
                var headerMap = {};
                var allHeaders = this.xhr.getAllResponseHeaders() || "";
                return allHeaders.split(MULTIPLE_NEWLINE_RX).reduce(function (headerAggregator, header) {
                    var separatorIndex = header.indexOf(":");
                    var key = header.substr(0, separatorIndex);
                    var value = header.substr(separatorIndex + 1).trim();
                    headerAggregator[key] = value;
                    return headerAggregator;
                }, headerMap);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(XmlHttpResponse.prototype, "responseText", {
            get: function () {
                return this.xhr.responseText;
            },
            enumerable: false,
            configurable: true
        });
        return XmlHttpResponse;
    }());
    var XmlHttpRequestHandler = (function () {
        function XmlHttpRequestHandler(method, url) {
            this.xhr = new XMLHttpRequest();
            this.xhr.open(method, url, true);
            this._url = url;
        }
        Object.defineProperty(XmlHttpRequestHandler.prototype, "url", {
            get: function () {
                return this._url;
            },
            enumerable: false,
            configurable: true
        });
        XmlHttpRequestHandler.prototype.createRequestCallback = function (callback) {
            var _this = this;
            return function (_) {
                var response = new XmlHttpResponse(_this, _this.xhr);
                callback(response);
            };
        };
        XmlHttpRequestHandler.prototype.setTimeout = function (value) {
            this.xhr.timeout = value;
        };
        XmlHttpRequestHandler.prototype.setBody = function (body) {
            this.body = body;
        };
        XmlHttpRequestHandler.prototype.setHeader = function (name, value) {
            this.xhr.setRequestHeader(name, value);
        };
        XmlHttpRequestHandler.prototype.isDone = function () {
            return this.xhr.readyState === RequestReadyStates.Done;
        };
        XmlHttpRequestHandler.prototype.send = function () {
            if (!!this.onSuccess) {
                this.xhr.onload = this.createRequestCallback(this.onSuccess);
            }
            if (!!this.onError) {
                this.xhr.onerror = this.createRequestCallback(this.onError);
            }
            if (!!this.onTimeout) {
                this.xhr.ontimeout = this.createRequestCallback(this.onTimeout);
            }
            if (!!this.onAbort) {
                this.xhr.onabort = this.createRequestCallback(this.onAbort);
            }
            if (!!this.onFinish) {
                this.xhr.onloadend = this.createRequestCallback(this.onFinish);
            }
            this.xhr.send(RequestUtils.formatDataToBeSent(this.body));
        };
        XmlHttpRequestHandler.prototype.abort = function () {
            this.xhr.abort();
        };
        return XmlHttpRequestHandler;
    }());
    function createHttpRequest(_a) {
        return tslib_1.__awaiter(this, arguments, void 0, function (_b) {
            var isNativeHttpPluginAvailable, requestUrl;
            var method = _b.method, url = _b.url, _c = _b.basePath, basePath = _c === void 0 ? DEFAULT_BASE_PATH : _c, _d = _b.nativeHttpPluginAvailable, nativeHttpPluginAvailable = _d === void 0 ? NativeHttp.isNativeHttpPluginAvailable : _d, _e = _b.createNativeHttpRequest, createNativeHttpRequest = _e === void 0 ? NativeHttp.createNativeHttpRequest : _e;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4, nativeHttpPluginAvailable()];
                    case 1:
                        isNativeHttpPluginAvailable = _f.sent();
                        requestUrl = "/".concat(basePath, "/").concat(url).replace(new RegExp("/(/)+", "gm"), "/");
                        if (!isNativeHttpPluginAvailable) return [3, 3];
                        return [4, createNativeHttpRequest(method, requestUrl)];
                    case 2: return [2, _f.sent()];
                    case 3: return [2, new XmlHttpRequestHandler(method, requestUrl)];
                }
            });
        });
    }
    exports.createHttpRequest = createHttpRequest;
});
//# sourceMappingURL=Request.js.map;
